module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image18.f630d4c5.jpg";